import PiInputfield from "../../../components/PiInputField";
import Interaction from "../../../models/interactions/Interaction";
import { ITriggerEvent } from "../../../models/interactions/TriggerEvent";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";

export default function TriggerEventNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const interaction = props.interaction as ITriggerEvent;
  const { updateInteraction } = useUpdateSequenceInteraction();

  return (
    <div className="w-full h-full flex flex-col gap-[12px]">
      <PiInputfield
        label="Event Name"
        placeholder="Event Name"
        value={interaction.eventName}
        onChange={(eventName) =>
          updateInteraction(props.nodeId, {
            ...interaction,
            eventName,
          } as ITriggerEvent)
        }
      />
    </div>
  );
}
